import { Fragment, useState } from "react";
import { Container, Row, Col, Table, Card, CardHeader } from "reactstrap";
import SubNavbar from "components/Navbars/SubNavbar";
import Select from 'react-select'
import { DropdownIndicator } from 'components/Inputs/Select'
import TextTransition, { presets } from "react-text-transition";
import { DOCTOR_TABLE_COLUMNS as columns } from "consts";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import RemindMeLater from '../../assets/img/icons/remindmelater.svg'
import Offwrist from '../../assets/img/icons/offwrist.svg'
import WatchNotConnected from '../../assets/img/icons/watchNotConnected.svg'
import Alerton from '../../assets/img/icons/alerton.svg'
import List from '../../assets/img/icons/list.svg'
import Grid from '../../assets/img/icons/grid.svg'
import GridOff from '../../assets/img/icons/grid-off.svg'
import ListOn from '../../assets/img/icons/list-on.svg'
import pinnedon from '../../assets/img/icons/pinnedon.svg'
import pinnedoff from '../../assets/img/icons/pinnedoff.svg'
import '../../assets/css/patient-list.css'
import { convertStringToClassName } from "utils";


const Doctor = (props) => {
    const { patients, socketPatientsData } = useSelector(state => state)
    const [searchedPatients, setSearchedPatients] = useState([])
    const [isCardsView, setIsCardsView] = useState(localStorage.getItem('view') === 'list' ? true : false)
    const [pinedPatients, setPinedPatients] = useState(JSON.parse(localStorage.getItem('pinedPatients') || '[]'))
    const history = useHistory()
    let sortByAlertsLength, sortByRemindAlertsLength, sortByPinLength
    const approvedPatients = getApprovedPatient(patients)
    function getApprovedPatient(patients) {
        const pinedPatients = JSON.parse(localStorage.getItem('pinedPatients') || '[]')
        return patients?.filter(p => p.status === 'approved').map(p => ({
            ...p,
            name: `${p.firstName} ${p.lastName}`,
            pinStatus: pinedPatients.includes(p.id)
        }))
    }

    const patinetRowClick = (patient, index) => {
        history.push(`/patient=${patient.id}/Dashboard`)
    }
    const isAlertAf = (alerts) => {
        let isAf = false
        alerts.forEach(al => {
            if (al?.alertType === 'PPG AF') isAf = true
        });
        return isAf
    }

    const handleStatus = (event, id) => {
        event.stopPropagation();
        let pinedPatients = JSON.parse(localStorage.getItem('pinedPatients') || '[]');
        if (pinedPatients.includes(id)) {
            pinedPatients = pinedPatients.filter((pId) => pId !== id)
        } else {
            pinedPatients.push(id)
        }

        localStorage.setItem('pinedPatients', JSON.stringify(pinedPatients));
        setPinedPatients(pinedPatients)
    }

    const handleView = () => {
        setIsCardsView(!isCardsView)
        localStorage.setItem('view', !isCardsView ? 'list' : 'card')
    }

    const renderValue = (patient, data, key, label, dbAlerts, remindAlerts, index) => {
        if (key === 'status') {
            const displaySocketClose = !data && !remindAlerts.length && !dbAlerts?.length
            let src = Offwrist;
            if (data) src = null
            if (data?.connectionStatus?.value === 0) src = WatchNotConnected
            if (remindAlerts?.length) src = RemindMeLater
            if ((data?.onAlert && Object.values(data?.onAlert)?.length) || dbAlerts?.length) src = Alerton
            return src && <img className={`status m-auto d-block ${displaySocketClose && 'socket-close'}`} src={src} alt='status' />
        }
        if (key === 'af_alert') {
            return (
                <div className="ppg-detection">
                    <span className="hide-ppg-detection" >PPG Detection:</span>
                    {data?.onAlert?.AF || isAlertAf(dbAlerts) ?
                        <div className="rounded-circle circle" style={{ height: '30px', width: '30px', margin: 'auto', color: '#EF3054', border: '1px solid #EF3054', textAlign: 'center', fontSize: 13 }} >
                            AF
                        </div> : ''
                    }
                </div>
            )
        }
        if (key === 'Pin') {
            return (
                <span className="pin" onClick={(e) => handleStatus(e, patient.id)}>
                    <img key={patient.id} alt="pinStatus" src={patient.pinStatus ? pinnedon : pinnedoff} />
                </span>
            )
        }
        if (['Body Temp', 'SpO2', 'Blood Pressure', 'Respiratory Rate', 'Pulse Rate'].includes(key)) {
            return (
                <div style={{ display: 'flex', width: '100%' }}>
                    <div className="left-text" style={{ display: 'flex' }}>
                        <span className="list-none" style={{ fontSize: 20 }}>{`${label}:`}</span>
                        <TextTransition
                            springConfig={presets.wobbly}
                            text={key === 'Body Temp' && data?.[key]?.value ? Number(data?.[key]?.value).toFixed(1) : data?.[key]?.value || '--'}
                            style={{ color: data?.onAlert?.[key] ? '#EF3054' : '#000000', fontSize: 20 }}
                            className="measure-value" />
                        <span style={{ marginTop: 5, marginLeft: 5, color: '#000000', display: !data?.[key]?.value ? 'none' : 'inline' }}>{key === 'SpO2' ? '%' : data?.[key]?.unit}</span>
                    </div>
                </div>
            )
        }
        const titles = {phoneNumber: 'Phone:', idNumber: 'ID:'}
        if (['name', 'idNumber', 'phoneNumber'].includes(key)) {
            return <div className={`id-text ${key} text-start`}>
                <div className="name-container">
                    <span className="list-none pr-2">{titles[key]}</span> 
                    <span>{patient[key]}</span>
                </div>
                {key === 'phoneNumber' && <div className="line list-none" />}
            </div>
        }
    }

    function sortPatients() {
        if (searchedPatients.length) {
            const filterdPatients = approvedPatients.filter((item) => searchedPatients.includes(item.id))
            return filterdPatients
        }
        const sortByAlerts = []
        const sortByRemindAlerts = []
        const sortBySocketConnecting = []
        const sortByPinStatus = []
        const rest = []
        for (let i = 0; i < approvedPatients.length; i++) {
            const p = approvedPatients[i];
            if (p.pinStatus) { sortByPinStatus.push(p); continue }
            if ((socketPatientsData?.[p.id]?.onAlert && Object.values(socketPatientsData?.[p.id]?.onAlert).length) || p.alerts?.length) { sortByAlerts.push(p); continue }
            if (p.remindAlerts?.length) { sortByRemindAlerts.push(p); continue }
            if (!socketPatientsData?.[p.id]) { sortBySocketConnecting.push(p); continue }
            rest.push(p)
        };
        sortByAlertsLength = sortByAlerts.length
        sortByRemindAlertsLength = sortByRemindAlerts.length
        sortByPinLength = sortByPinStatus.length
        return [...sortByPinStatus, ...sortByAlerts, ...sortByRemindAlerts, ...sortBySocketConnecting, ...rest]
    }

    return (
        <div style={{ backgroundColor: '#F2F6FA' }}>
            <SubNavbar title={'Patient List'} subPages={['Patient List']}>
                <div className="hamburger-container">
                    <img className="first-img" src={isCardsView ? List : ListOn} onClick={() => handleView()} alt='Hamburger' />
                    <div className="line"></div>
                    <img style={{ cursor: 'pointer' }} src={isCardsView ? Grid : GridOff} onClick={() => { handleView() }} alt='Hamburger' />

                </div>
            </SubNavbar>
            <div>
                <Container className={`${isCardsView ? 'cards-view' : 'list-view'}`} fluid style={{ maxWidth: '2000px', minWidth: '70%' }}>
                    <Row className="mt-3" >
                        <Col xl="12">
                            <div className="">
                                <CardHeader className="border-0 " style={{ padding: 10 }}>
                                    <Select options={approvedPatients?.map((p, i) => { return { value: i, label: p.name, id: p.id } })}
                                        isClearable isMulti
                                        placeholder="Search"
                                        onChange={(choice) => {
                                            const idSelectedPatients = choice.map(c => c.id)
                                            setSearchedPatients(idSelectedPatients)
                                        }}
                                        components={{ DropdownIndicator }} />
                                </CardHeader>
                                <Table className="align-items-center table-flush patients-table" responsive style={{ overflow: 'hidden' }}>
                                    <thead className="thead-light card-none">
                                        <tr>{columns.map(({ label, value }) => {
                                            return (
                                                label === 'pin' ?
                                                    <th className="box" key={label} scope="col">
                                                        <img alt="pin" src={pinnedon} />
                                                    </th>
                                                    :
                                                    <th scope="col"
                                                        className={`box ${convertStringToClassName(value)}`}
                                                        key={label}>{label}
                                                    </th>
                                            )
                                        }
                                        )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sortPatients().map((patient, index) =>
                                            <Fragment key={patient.id}>
                                                {
                                                    index === sortByAlertsLength + sortByRemindAlertsLength + sortByPinLength &&
                                                    <tr className="cards-line"></tr>
                                                }
                                                <tr onClick={() => patinetRowClick(patient, index)} className="doctor-table-row" key={patient.id}>
                                                    {columns.map(({ value: key, label }) => {
                                                        const patientSocketData = socketPatientsData?.[patient.id]
                                                        const dbAlerts = patient.alerts
                                                        return (
                                                            <td key={key}>
                                                                {renderValue(patient, patientSocketData, key, label, dbAlerts, patient.remindAlerts, index)}
                                                            </td>)
                                                    })}
                                                </tr>
                                            </Fragment>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}
export default Doctor